<template>
  <div class="markers-panel events__item-icons">
    <div v-for="(marker, index) in markers" :key="index" class="marker events__item-icon"
      @click="toggleTooltip($event, index)">
      <template v-if="marker.type === 'label'">
        <span v-if="marker.label" class="marker-label">{{ marker.label }}</span>
        <img v-if="marker.logo" :src="`/api/pis/v1/images/${marker.logo}`" alt="marker icon" class="marker-icon" />
      </template>

      <template v-else>
        <p v-for="info in marker.tooltip?.info" :key="info.type">
          <span class="events__item-price" v-if="info.type === 'cost'">{{ info.cost }}</span>
        </p>
        <img v-if="marker.logo" :src="`/api/pis/v1/images/${marker.logo}`" alt="marker icon" class="marker-icon" />
      </template>

      <div v-if="activeTooltip === index && marker.tooltip !== null" class="tooltip">
        <div class="tooltip__wrap">
          <i class="tooltip__triangle">
            <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_937_5699)">
                <path
                  d="M13.0982 8.23206C11.9435 10.2321 9.05674 10.2321 7.90203 8.23206L3.36057 0.366014L17.6396 0.366014L13.0982 8.23206Z"
                  fill="white" />
              </g>
              <defs>
                <filter id="filter0_d_937_5699" x="0.360596" y="0.366028" width="20.2791" height="16.366"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="1.5" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_937_5699" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_937_5699" result="shape" />
                </filter>
              </defs>
            </svg>
          </i>
          <p v-for="info in marker.tooltip?.info" :key="info.type">
            <span v-if="info.type === 'label_count'">{{ info.label }} {{ info.count }}</span>
            <span class="event__marker-message" v-if="info.type === 'message'">{{ info.message }}</span>
          </p>
          <template v-if="marker.tooltip?.interact">
            <div v-if="marker.tooltip.interact.type === 'button_count'">
              <div class="event__counter">
                <button @click.stop="updateCount(marker.tooltip.interact, -1)"
                  :disabled="marker.tooltip.interact.currentCount <= 0">
                  <i>
                    <svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.5 0.5H7.5" stroke="#333333" />
                    </svg>
                  </i>
                </button>
                <p class="event__block-count">{{ marker.tooltip.interact.currentCount || 1 }}</p>
                <button @click.stop="updateCount(marker.tooltip.interact, 1)"
                  :disabled="marker.tooltip.interact.currentCount >= marker.tooltip.interact.maxCount">
                  <i>
                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 0V7M0.5 3.5H7.5" stroke="#333333" />
                    </svg>
                  </i>
                </button>
              </div>
            </div>
            <a v-if="marker.tooltip.interact.action.type === 'phone'"
                :href="`tel:${marker.tooltip.interact.action.phone}`" class="interact-link" @click.stop>
                {{ marker.tooltip.interact.label }}
              </a>
            <a v-else-if="marker.tooltip.interact.type === 'link'" :href="marker.tooltip.interact.link" target="_blank"
              class="interact-link" @click.stop>
              Перейти по ссылке
            </a>
            <button v-else class="login__btn" @click.stop="reserve(marker.tooltip?.interact, index)" :disabled="isLoading"
              :class="{ 'login__btn--loading': isLoading, 'registered': beRegistered, 'registeredSuccess': beRegisteredSuccess }" type="submit">              
              {{ isLoading ? 'Регистрируем…' : (this.errorText || marker.tooltip.interact.label) }}
            </button>

            <p v-if="reservationStatus"
              :class="{ 'success-message': reservationStatus.success, 'error-message': !reservationStatus.success }">
              {{ reservationStatus.message }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';

export default {
  emits: ['refresh'],
  props: {
    markers: {
      type: Array,
      required: true,
    },
    eventId: Number,
    event: Object,
  },
  data() {
    return {
      activeTooltip: null,
      count: 1,
      isLoading: false,
      reservationStatus: null,
      beRegistered: false,
      beRegisteredSuccess: false,
      errorText: null,
    };
  },
  methods: {
    // Метод для переключения подсказки
    toggleTooltip(event, index) {
      event.stopPropagation();
      // Закрываем текущую подсказку, если открыта другая
      this.activeTooltip = this.activeTooltip === index ? null : index;
    },

    // Метод для обновления количества
    updateCount(interact, change) {
      const newCount = (interact.currentCount || 1) + change;
      interact.currentCount = Math.max(0, Math.min(newCount, interact.maxCount));
      this.count = interact.currentCount;
    },

    // Метод для резервирования
    reserve(interact, index) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));

      if (interact.action.registration === 'fast') {
        if (userInfo) {
          this.isLoading = true;
          const requestBody = {
            eventId: this.eventId,
            reservCount: interact.currentCount || 1,
            name: userInfo.name,
            surname: userInfo.surname,
            email: userInfo.email,
            phone: userInfo.phone,
          };

          const config = {
            headers: {
              'Content-Type': 'application/json',
            },
          };

          axios
            .post('/api/pis/v1/for_account/reserv', requestBody, config)
            .then(response => {
              setTimeout(() => {
                this.$emit('refresh');                
              }, 1000);
              this.isLoading = false;
              this.beRegisteredSuccess = true;
              this.errorText = 'Уже зарезервированы';
            })
            .catch(error => {                       
              this.isLoading = false;
              this.beRegistered = true;
              this.errorText = 'Уже зарезервированы';
            });
        } else {
          if (interact.action.type == 'reserv') {
            this.activeTooltip = null;
            this.$emit('open-signup-event-modal', {
              event: this.event,
              count: interact.currentCount || 1,
              requiredPhone: false,
            });
          } else {
            this.activeTooltip = null;
            this.$emit('open-signup-event-multi-modal', {
              event: this.event,
              count: interact.currentCount || 1,
              requiredPhone: false,
            });
          }
        }
      } else if (interact.action.registration === 'requiredPhone') {
        if (interact.action.type == 'reserv') {
          this.activeTooltip = null;
          this.$emit('open-signup-event-modal', {
            event: this.event,
            count: interact.currentCount || 1,
            requiredPhone: true,
          });
        } else {
          this.activeTooltip = null;
          this.$emit('open-signup-event-multi-modal', {
            event: this.event,
            count: interact.currentCount || 1,
            requiredPhone: true,
          });
        }
      } else {
        if (interact.action.type == 'reserv') {
          this.activeTooltip = null;
          this.$emit('open-signup-event-modal', {
            event: this.event,
            count: interact.currentCount || 1,
            requiredPhone: false,
          });
        } else {
          this.activeTooltip = null;
          this.$emit('open-signup-event-multi-modal', {
            event: this.event,
            count: interact.currentCount || 1,
            requiredPhone: false,
          });
        }
      }
    },

    // Закрытие подсказки при клике вне маркера
    closeTooltipOutsideClick(event) {
      // Закрываем подсказку, если клик был вне маркера
      if (!event.target.closest('.marker')) {
        this.activeTooltip = null;
      }
    }
  },

  mounted() {
    // Добавляем обработчик для глобальных кликов
    document.addEventListener('click', this.closeTooltipOutsideClick);
  },

  beforeDestroy() {
    // Убираем обработчик при уничтожении компонента
    document.removeEventListener('click', this.closeTooltipOutsideClick);
  },
};
</script>
